import {createFeatureSelector, createSelector} from '@ngrx/store';
import {State} from './production-instance.delete-many.reducer';

export const deleteManyProductionInstancesFeatureKey = 'deleteManyProductionInstances';
export const featureSelector = createFeatureSelector<State>(deleteManyProductionInstancesFeatureKey);

export const getDeleteManyProductionInstancesRecord = createSelector(
  featureSelector,
  (state: State): null => state.record
);

export const getDeleteManyProductionInstancesLoaded = createSelector(
  featureSelector,
  (state: State): boolean => state.loaded
);

export const getDeleteManyProductionInstancesLoading = createSelector(
  featureSelector,
  (state: State): boolean => state.loading
);

export const getDeleteManyProductionInstancesError = createSelector(
  featureSelector,
  (state: State): any => state.error
);
